export const LOGIN = "/login";
export const HOMEPAGE = "/";
export const SOCIAL = "/social";
export const LOCATION = "/location";
export const CERTIFICATION = "/certification";
export const PERFORMANCE = "/performance";
